import { Component } from "@angular/core";
import { StatutDossier } from "../core/model/statut-dossier";
import { StatutDossierService } from "../core/service/statut-dossier.service";

@Component({
  selector: "app-statut-dossier",
  templateUrl: "./statut-dossier.component.html",
  styleUrls: ["./statut-dossier.component.scss"],
})
export class StatutDossierComponent {
  statuts: StatutDossier[];

  constructor(private _statutDossierService: StatutDossierService) {}

  ngOnInit() {
    this.getAllStatutDossier();
  }

  getAllStatutDossier() {
    this._statutDossierService.getAllStatutDossier().subscribe(
      (data) => {
        this.statuts = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
